import { InputLabel } from '@mui/material';
import { disabledTextAreaInputStyles } from '@Components/Form/styles';
import FormTextAreaAutoSize from '@Components/Form/FormTextAreaAutosize';

type ValueUpPlanNameFormFieldsProps = {
  planIndex: number;
  isCompletedTh?: boolean;
  isCompletedEn?: boolean;
};

const ValueUpPlanNameFormFields = ({
  planIndex,
  isCompletedTh = false,
  isCompletedEn = false,
}: ValueUpPlanNameFormFieldsProps) => {
  return (
    <>
      <InputLabel required>ระบุชื่อแผน</InputLabel>
      <FormTextAreaAutoSize
        name={`companyValueIncreasePlans.valueUpPlans.${planIndex}.nameTh`}
        inputProps={{
          minRows: 3,
          placeholder: 'กรุณาระบุชื่อแผน (ไทย)',
        }}
        label={'ภาษาไทย'}
        sx={
          isCompletedTh ? { ...disabledTextAreaInputStyles, mt: 2 } : { mt: 2 }
        }
      />
      <FormTextAreaAutoSize
        name={`companyValueIncreasePlans.valueUpPlans.${planIndex}.nameEn`}
        inputProps={{
          minRows: 3,
          placeholder: 'กรุณาระบุชื่อแผน (อังกฤษ)',
        }}
        label={'ภาษาอังกฤษ'}
        sx={
          isCompletedEn ? { ...disabledTextAreaInputStyles, mt: 2 } : { mt: 2 }
        }
      />
    </>
  );
};

export default ValueUpPlanNameFormFields;
